"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteGuardProvider = exports.RouteGuardContext = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reducer_1 = require("./reducer");
const types_1 = require("./types");
/**
 * The RouteGuardProvider should be used as a RouteGuard that prevents user from leaving page and gives user options to resolve staying/leaving page
 */
exports.RouteGuardContext = react_1.default.createContext(null);
function RouteGuardProvider({ children } = {}) {
    const [state, dispatch] = react_1.useReducer(reducer_1.routeGuardReducer, reducer_1.getInitialState());
    const navigate = react_router_dom_1.useNavigate();
    const handleRouteAction = () => {
        const { routeAction, nextLocation } = state;
        if (routeAction === 'PUSH' && nextLocation) {
            navigate(nextLocation.pathname);
        }
        else {
            navigate(-1);
        }
    };
    const continueEditing = react_1.useCallback(() => {
        dispatch({ type: types_1.ROUTE_GUARD_ACTION.CONTINUE_EDITING });
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const subscribe = react_1.useCallback(listener => {
        dispatch({ type: types_1.ROUTE_GUARD_ACTION.SET_LISTENERS, payload: [listener] });
        return function unsubscribe() {
            dispatch({
                type: types_1.ROUTE_GUARD_ACTION.SET_LISTENERS,
                payload: state.listeners.filter(x => x !== listener)
            });
        };
    }, []);
    const blockRoute = react_1.useCallback(() => {
        dispatch({ type: types_1.ROUTE_GUARD_ACTION.BLOCK_ROUTE });
    }, []);
    const unblockRoute = react_1.useCallback(() => {
        dispatch({ type: types_1.ROUTE_GUARD_ACTION.UNBLOCK_ROUTE });
    }, []);
    const closeModal = react_1.useCallback(() => {
        return dispatch({ type: types_1.ROUTE_GUARD_ACTION.CLOSE_MODAL });
    }, []);
    const setRouteInfo = react_1.useCallback((nextLocation, routeAction) => {
        return dispatch({
            type: types_1.ROUTE_GUARD_ACTION.SET_ROUTE_INFO,
            payload: { nextLocation, routeAction }
        });
    }, []);
    const resetState = react_1.useCallback(() => {
        return dispatch({ type: types_1.ROUTE_GUARD_ACTION.RESET_STATE });
    }, []);
    react_1.useEffect(() => {
        // TODO TEST
        if (!state.isRouterBlocked && state.nextLocation && state.routeAction) {
            handleRouteAction();
            resetState();
        }
        const nextLocation = location;
        const unblockHistory = () => {
            if (state.isRouterBlocked) {
                setRouteInfo(nextLocation, types_1.ROUTE_GUARD_ACTION.UNBLOCK_ROUTE);
            }
            else {
                resetState();
            }
            return !state.isRouterBlocked;
        };
        return () => {
            unblockHistory();
        };
    }, [state.isRouterBlocked, state.nextLocation, state.routeAction, location]);
    return (react_1.default.createElement(exports.RouteGuardContext.Provider, { value: [state, { subscribe, blockRoute, unblockRoute, closeModal, continueEditing }] }, children));
}
exports.RouteGuardProvider = RouteGuardProvider;
